import Grid2 from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useApiKey } from '../../contexts/ApiKeyContext';

export const Profile = () => {
  const { userProfile } = useApiKey();

  return (
    <>
      <Typography variant="h5">Profil użytkownika</Typography>
      <Grid2 container spacing={3}>
        {userProfile && (
          <>
            <Grid2 size={{ xs: 12 }}>
              <Paper>
                <Typography>Imię: {userProfile.name}</Typography>
                <Typography>Nazwisko: {userProfile.surname}</Typography>
                <Typography>Mail: {userProfile.login}</Typography>
                <Typography>Telefon: {userProfile.phoneNumber}</Typography>
              </Paper>
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <Paper>
                <Typography>Drużyny: {userProfile.ownedSoccerTeams?.length}</Typography>
                {userProfile.ownedSoccerTeams?.map((team) => <Typography>{team.name}</Typography>)}
              </Paper>
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <Paper>
                <Typography>Zgody</Typography>
                <Typography>Regulamin: {userProfile.regulationsConsent ? 'TAK' : 'NIE'}</Typography>
                <Typography>RODO: {userProfile.gdprConsent ? 'TAK' : 'NIE'}</Typography>
                <Typography>Marketing: {userProfile.marketingConsent ? 'TAK' : 'NIE'}</Typography>
              </Paper>
            </Grid2>
          </>
        )}
      </Grid2>
    </>
  );
};
